import {
    instance as axiosInstance,
    withHeaders,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { themeObject } from '../../lib';
import { ChainMetrics } from './components/dashboard-chart/dashboard-chart-helpers';

export const allMetricsUrl = '/metrics/sdz';

export const getQueryData = async (
    url: string,
    token: string
): Promise<any> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response.data;
};

export const useQueryProps = {
    retry: false,
    refetchOnWindowFocus: false,
};

export const dashboardStyles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    metricsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        mb: 1,
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        mt: 2.5,
    },
    titleContainerSpacing: {
        mb: 1,
    },
    emptyTitleContainerSpacing: {
        mb: 15,
    },
    title: {
        ...themeObject.typography.h2,
        color: themeObject.palette.primary[700],
        fontWeight: 600,
    },
    timestamp: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
    },
    metricsCard: {
        mb: { xs: 4, md: 0 },
        display: 'flex',
    },
    disclaimerContainer: {
        pt: 0.5,
    },
    disclaimer: {
        fontFamily: 'Red Hat Text',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '15.88px',
        letter: '0.4px',
        color: themeObject.palette.grayScale[600],
    },
};

export interface Metrics {
    chainMetrics?: ChainMetrics;
    customer: string;
    enabled: boolean;
    lastUpdated: string;
    realm: string;
    sdz: string;
    totalBlobs?: number;
    totalBlobsGB?: number;
    totalEdges?: number;
    totalNodes?: number;
    totalBlobsBytes?: number;
    error?: string;
    id?: string;
    message?: string;
    status?: number;
    timestamp?: string;
}
